import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
import { NavLink, Link, withRouter } from 'react-router-dom'
import ReactResizeDetector from 'react-resize-detector'
import OutsideClickHandler from 'react-outside-click-handler'

import {
    AUTH__LOGOUT,
    COMMON__SET_LANGUAGE,
    SERVICE__STYLES__SET_HEADER_SIZES,
    SERVICE__SET_NAV_MENU_WIDTH,
} from '../store/actions'

/**
 * Basic logo
 * import Logo from '../svg/header_logo.svg'
 * Beta logo
 * import Logo from '../svg/header_logo_beta.svg'
 */

import Logo from '../svg/header_logo.svg'

import { IconTriangleBottom } from '../svg'

import Profile from './Profile'

import Modal from './Modal'

import languages from '../i18n/languages'

class Header extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            isActiveMenu: false,
            is_open_lng_menu: false,
            is_open_lng_menu_mobile: false,

            is_open_more_menu: false,
            more_btn_width_: {
                en: 81,
                ru: 75,
            },

            drop_menu_active_label: null,

            menu: [
                {
                    auth_required: true,
                    has_child: false,
                    to: '/account/my-projects',
                    label: props.t('_components._header._nav.my_projects'),
                    width: {
                        en: 68, // real val = this + 16 (side padding fix)
                        ru: 86, // real val = this + 16 (side padding fix)
                    },
                },
                {
                    auth_required: false,
                    guest_only: false,
                    has_child: true,
                    label: props.t('_components._header._nav.products'),
                    width: {
                        en: 110,
                        ru: 120,
                    },
                    children: [
                        {
                            to: '/products/instant-pages',
                            label: props.t('Interactive worksheets'),
                            icon: require('../svg/header/instant-pages.svg'),
                        },
                        {
                            to: '/products/trivia-quiz',
                            label: props.t('_components._header._nav._products.trivia_quiz'),
                            icon: require('../svg/header/trivia.svg'),
                        },
                        {
                            to: '/products/personality-quiz',
                            label: props.t('_components._header._nav._products.personality_quiz'),
                            icon: require('../svg/header/personality.svg'),
                        },
                        {
                            to: '/products/memory-game',
                            label: props.t('_components._header._nav._products.memory'),
                            icon: require('../svg/header/memory.svg'),
                        },
                        {
                            to: '/products/before-after',
                            label: props.t('_components._header._nav._products.before_after'),
                            icon: require('../svg/header/before-after.svg'),
                        },
                        {
                            to: '/products/timeline',
                            label: props.t('_components._header._nav._products.timeline'),
                            icon: require('../svg/header/timeline.svg'),
                        },
                        {
                            to: '/products/cookies',
                            label: props.t('Fortune cookies'),
                            icon: require('../svg/header/cookies.svg'),
                        },
                        {
                            to: '/products/horoscope',
                            label: props.t('Horoscope'),
                            icon: require('../svg/header/horoscope.svg'),
                        },
                        {
                            to: '/products/interactive-image',
                            label: props.t('_components._header._nav._products.interactive-image'),
                            icon: require('../svg/header/zoom-map.svg'),
                        },
                        {
                            to: '/products/hidden-objects',
                            label: props.t('Hidden objects'),
                            icon: require('../svg/header/hidden-objects.svg'),
                        },
                        {
                            to: '/products/rank-battle',
                            label: props.t('_components._header._nav._products.rank_battle'),
                            icon: require('../svg/header/rank-battle.svg'),
                        },
                        {
                            to: '/products/photostory',
                            label: props.t('_components._header._nav._products.photostory'),
                            icon: require('../svg/header/photostory.svg'),
                        },
                        {
                            to: '/products/quotes',
                            label: props.t('_components._header._nav._products.quotes'),
                            icon: require('../svg/header/quotes.svg'),
                        },
                    ],
                },
                {
                    auth_required: false,
                    guest_only: false,
                    has_child: false,
                    to: '/template-gallery',
                    label: props.t('_components._header._nav.template_gallery'),
                    width: {
                        en: 118,
                        ru: 142,
                    },
                },
                {
                    auth_required: false,
                    guest_only: false,
                    has_child: false,
                    to: '/how-it-works',
                    label: props.t('_components._header._nav.how_it_works'),
                    width: {
                        en: 94,
                        ru: 128,
                    },
                },
                {
                    auth_required: true,
                    has_child: false,
                    to: '/account/billing-and-payments?tab=subscription',
                    label: props.t('_components._header._nav.subscription'),
                    width: {
                        en: 90,
                        ru: 74,
                    },
                    'data-test': 'subscription-page',
                },
                {
                    auth_required: false,
                    guest_only: true,
                    has_child: true,
                    label: props.t('_components._header._nav.pricing'),
                    width: {
                        en: 94,
                        ru: 103,
                    },
                    children: [
                        {
                            to: '/pricing/education',
                            label: props.t('Education'),
                        },
                        {
                            to: '/pricing/business',
                            label: props.t('Business'),
                        },
                    ],
                },

                {
                    auth_required: false,
                    // guest_only: true,
                    has_child: true,
                    label: props.t('Knowledge base'),
                    width: {
                        en: 161,
                        ru: 137,
                    },
                    children: [
                        {
                            isExternal: true,
                            newTab: true,
                            to: 'https://blog.interacty.me',
                            label: props.t('Blog'),
                        },
                        {
                            isExternal: true,
                            newTab: true,
                            to: 'https://ask.interacty.me',
                            label: props.t('Forum'),
                        },
                    ],
                },

                {
                    auth_required: false,
                    guest_only: true,
                    has_child: false,
                    to: '/about',
                    label: props.t('_components._header._nav.about'),
                    width: {
                        en: 44,
                        ru: 92,
                    },
                },
                {
                    auth_required: false,
                    guest_only: false,
                    has_child: false,
                    to: '/contacts',
                    label: props.t('_components._header._nav.contacts'),
                    width: {
                        en: 66,
                        ru: 74,
                    },
                },
            ],
            menu_profile: [
                {
                    to: '/account/my-projects',
                    label: props.t('_components._header._nav.my_projects'),
                },
                {
                    to: '/account/settings',
                    label: props.t('_components._header._nav.account_settings'),
                },
                {
                    to: '/account/billing-and-payments',
                    label: props.t('_components._header._nav.billing_and_payments'),
                },
            ],
        }

        this.ref_menu = null
        this.refs_list = []
    }

    async componentDidMount() {
        this._isMounted = true
    }

    async componentDidUpdate() {}

    componentWillUnmount() {
        this._isMounted = false
    }

    toggleMenu = () => {
        const { isActiveMenu } = this.state
        this.setState({ isActiveMenu: !isActiveMenu })
    }

    onResize__header = async (width, height) => {
        const {
            header_width,
            header_height,
            nav_menu_width,
            P__SERVICE__STYLES__SET_HEADER_SIZES,
            P__SERVICE__SET_NAV_MENU_WIDTH,
        } = this.props
        if (width !== header_width || header_height !== height) {
            await P__SERVICE__STYLES__SET_HEADER_SIZES({
                width,
                height,
            })
        }
        if (this.ref_menu && nav_menu_width !== this.ref_menu.offsetWidth) {
            P__SERVICE__SET_NAV_MENU_WIDTH(this.ref_menu.offsetWidth)
        }
    }

    handleClick__link = target => async evt => {
        evt.preventDefault()
        this.props.history.push(target)
    }

    handleClick__change_language = item => async evt => {
        evt.preventDefault()
        try {
            if (item.is_enabled) {
                const { P__COMMON__SET_LANGUAGE } = this.props
                await P__COMMON__SET_LANGUAGE(item.value)
                document.location.reload()
            }
        } catch (err) {
            console.error(err)
        }
    }

    handleClick__toggle_lng_menu = async evt => {
        evt.preventDefault()
        await this.setState(prevState => ({
            is_open_lng_menu: !prevState.is_open_lng_menu,
        }))
    }
    handleClick__close_lng_menu = async evt => {
        evt.preventDefault()
        await this.setState({
            is_open_lng_menu: false,
        })
    }

    handleClick__open_lng_menu_mobile = async evt => {
        evt.preventDefault()
        await this.setState({
            is_open_lng_menu_mobile: true,
        })
    }
    handleClick__close_lng_menu_mobile = async evt => {
        evt.preventDefault()
        await this.setState({
            is_open_lng_menu_mobile: false,
        })
    }

    handleClick__toggle_more_menu = async evt => {
        evt.preventDefault()
        await this.setState(prevState => ({
            is_open_more_menu: !prevState.is_open_more_menu,
        }))
    }
    handleClick__close_more_menu = async evt => {
        // evt.preventDefault()
        await this.setState({
            is_open_more_menu: false,
        })
    }

    handleClick__toggle_drop_menu = label => async evt => {
        evt.preventDefault()
        await this.setState(prevState => ({
            drop_menu_active_label: prevState.drop_menu_active_label === label ? null : label,
        }))
    }
    handleClick__close_drop_menu = (from_mobile_menu, close_burger) => async evt => {
        // evt.preventDefault()
        const { isActiveMenu } = this.state

        if (from_mobile_menu) {
            await this.setState({
                drop_menu_active_label: null,
                isActiveMenu: close_burger,
            })
        } else {
            if (!isActiveMenu) {
                await this.setState({
                    drop_menu_active_label: null,
                })
            }
        }
    }

    handleClick__logout = async evt => {
        evt.preventDefault()

        const { P__AUTH__LOGOUT } = this.props

        await this.setState({
            isActiveMenu: false,
        })
        await P__AUTH__LOGOUT()
    }

    render() {
        const { is_auth, user, user_details, t, i18n, header_height, nav_menu_width } = this.props
        const { menu } = this.state
        const {
            isActiveMenu,
            is_open_lng_menu,
            is_open_lng_menu_mobile,
            is_open_more_menu,
            menu_profile,
            more_btn_width_,
            drop_menu_active_label,
        } = this.state

        const burgerClassName = `hamburger hamburger--collapse ${isActiveMenu ? '  is-active' : ''}`

        const current_lng = languages.filter(el => el.value === i18n.language)[0]

        const menu_formatted = () => {
            const filtered = menu.filter(
                item =>
                    (!item.auth_required && (!item.guest_only || (item.guest_only && !is_auth))) ||
                    (item.auth_required && is_auth),
            )

            const side_padding = 32

            const width_values_arr = filtered.map(item => {
                return item.width[current_lng.code]
            })
            let last_visible_index = 0
            let accumulated_width = width_values_arr.reduce((acc, val) => acc + val + side_padding, 0) - side_padding

            if (accumulated_width > nav_menu_width) {
                for (let i = width_values_arr.length - 1; i !== 0; i--) {
                    if (
                        accumulated_width -
                            width_values_arr[i] -
                            side_padding +
                            (more_btn_width_[current_lng.code] + 16) <=
                        nav_menu_width
                    ) {
                        last_visible_index = i - 1
                        break
                    } else {
                        accumulated_width -= width_values_arr[i] + side_padding
                    }
                }
            } else {
                last_visible_index = width_values_arr.length - 1
            }

            return filtered.map((item, index) => {
                return {
                    id: index,
                    is_hidden: index > last_visible_index,
                    is_external: item.is_external,
                    newTab: item.newTab,
                    has_child: item.has_child,
                    to: item.has_child ? null : item.to,
                    children: item.has_child ? item.children : null,
                    label: item.label,
                    'data-test': item['data-test'],
                }
            })
        }
        const is_visible_more_menu = menu_formatted().findIndex(item => item.is_hidden) !== -1

        const avaText = () => {
            let result = user_details.email.charAt(0).toUpperCase()
            if (user_details.first_name && user_details.first_name.length) {
                result = user_details.first_name.charAt(0).toUpperCase()
            }
            if (user_details.last_name && user_details.last_name.length) {
                result = result + user_details.last_name.charAt(0).toUpperCase()
            }
            return result
        }
        const firstName = () => {
            let result = null
            if (user_details.first_name && user_details.first_name.length) {
                result = user_details.first_name
            }
            return result
        }
        const fullName = () => {
            let result = null
            if (user_details.first_name && user_details.first_name.length) {
                result = user_details.first_name
            }
            if (user_details.last_name && user_details.last_name.length) {
                result = result + ' ' + user_details.last_name
            }
            return result
        }

        return (
            <header className="header" id="header">
                <ReactResizeDetector
                    refreshMode="debounce"
                    refreshRate={0}
                    handleWidth
                    handleHeight
                    onResize={this.onResize__header}
                />
                <div className={`header-inner container-fluid${is_visible_more_menu ? ' with-more-menu' : ''}`}>
                    <div className="left" id="left-side">
                        <div className="left-inner">
                            <div className="left-inner-2">
                                <div className="logo">
                                    <Link to="/">
                                        <img src={Logo} alt="" />
                                    </Link>
                                </div>
                                <nav className="menu" ref={ref => (this.ref_menu = ref)}>
                                    <ul id="menu-list" className={is_auth ? 'is-auth' : ''}>
                                        {menu_formatted()
                                            .filter(item => !item.is_hidden)
                                            .map(item => {
                                                return (
                                                    <li
                                                        className={`${item.has_child ? 'with-dropdown' : ''}${
                                                            item.has_child && item.label === drop_menu_active_label
                                                                ? ' is-active'
                                                                : ''
                                                        }`}
                                                        ref={ref => (this.refs_list[item.id] = ref)}
                                                        key={item.id}
                                                        data-test={item['data-test']}
                                                    >
                                                        {item.is_external ? (
                                                            <a href={item.to} target={item.newTab ? '_blank' : '_self'}>
                                                                {item.label}
                                                            </a>
                                                        ) : !item.has_child ? (
                                                            <NavLink exact activeClassName="is-active" to={item.to}>
                                                                {item.label}
                                                            </NavLink>
                                                        ) : (
                                                            <OutsideClickHandler
                                                                onOutsideClick={this.handleClick__close_drop_menu(
                                                                    false,
                                                                )}
                                                            >
                                                                <div
                                                                    className="current"
                                                                    onClick={this.handleClick__toggle_drop_menu(
                                                                        item.label,
                                                                    )}
                                                                >
                                                                    {item.label}&nbsp;
                                                                    <IconTriangleBottom />
                                                                </div>
                                                                <ul className="list">
                                                                    {item.children.map(item => {
                                                                        return (
                                                                            <li key={item.label}>
                                                                                {item.icon ? (
                                                                                    <img src={item.icon} alt="icon" />
                                                                                ) : null}
                                                                                {item.isExternal ? (
                                                                                    <a
                                                                                        href={item.to}
                                                                                        target={
                                                                                            item.newTab
                                                                                                ? '_blank'
                                                                                                : '_self'
                                                                                        }
                                                                                    >
                                                                                        {item.label}
                                                                                    </a>
                                                                                ) : (
                                                                                    <NavLink
                                                                                        exact
                                                                                        activeClassName="is-active"
                                                                                        to={item.to}
                                                                                        onClick={this.handleClick__close_drop_menu(
                                                                                            false,
                                                                                        )}
                                                                                    >
                                                                                        {item.label}
                                                                                    </NavLink>
                                                                                )}
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            </OutsideClickHandler>
                                                        )}
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                    {is_visible_more_menu ? (
                                        <div className={`hide-menu${is_open_more_menu ? ' is-active' : ''}`}>
                                            <OutsideClickHandler onOutsideClick={this.handleClick__close_more_menu}>
                                                <div className="current" onClick={this.handleClick__toggle_more_menu}>
                                                    {t('_components._header.more')}&nbsp;
                                                    <IconTriangleBottom />
                                                </div>
                                                <ul className="list">
                                                    {menu_formatted()
                                                        .filter(item => item.is_hidden)
                                                        .map(item => {
                                                            return (
                                                                <li key={item.id}>
                                                                    {!item.has_child ? (
                                                                        <NavLink
                                                                            exact
                                                                            activeClassName="is-active"
                                                                            to={item.to}
                                                                        >
                                                                            {item.label}
                                                                        </NavLink>
                                                                    ) : null}
                                                                </li>
                                                            )
                                                        })}
                                                </ul>
                                            </OutsideClickHandler>
                                        </div>
                                    ) : null}
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        {!is_auth ? (
                            <div className="sign-up-mobile">
                                <button
                                    className="button"
                                    data-size="sm"
                                    data-variant="primary"
                                    onClick={this.handleClick__link(`/auth?action=registration`)}
                                >
                                    {t('_common.sign_up')}
                                </button>
                            </div>
                        ) : null}
                        <div className={burgerClassName} onClick={this.toggleMenu}>
                            <div className="hamburger-box">
                                <div className="hamburger-inner"></div>
                            </div>
                        </div>
                        {is_auth ? (
                            user_details ? (
                                <Profile
                                    menu={menu_profile}
                                    avaText={avaText()}
                                    isAdmin={!!user.optionalId}
                                    firstName={firstName()}
                                    fullName={fullName()}
                                />
                            ) : null
                        ) : (
                            <>
                                <div className={`lng-menu${is_open_lng_menu ? ' is-active' : ''}`}>
                                    <OutsideClickHandler onOutsideClick={this.handleClick__close_lng_menu}>
                                        <div
                                            className="current"
                                            data-lng={i18n.language}
                                            onClick={this.handleClick__toggle_lng_menu}
                                        >
                                            {current_lng && <img src={current_lng.icon} alt="" />}
                                        </div>
                                        <ul className="list">
                                            {languages
                                                .filter(el => el.is_visible)
                                                .map(el => {
                                                    return (
                                                        <li
                                                            key={el.code}
                                                            className={`${
                                                                i18n.language === el.value ? 'is-active ' : ''
                                                            }${el.is_enabled ? '' : 'is-disabled '}${
                                                                el.is_silent ? 'is-silent' : ''
                                                            }`}
                                                            onClick={this.handleClick__change_language(el)}
                                                        >
                                                            <img src={el.icon} alt="" />
                                                            <span
                                                                className={`${
                                                                    i18n.language === el.value ? 'is-active' : ''
                                                                }`}
                                                            >
                                                                {el.label}
                                                            </span>
                                                        </li>
                                                    )
                                                })}
                                        </ul>
                                    </OutsideClickHandler>
                                </div>
                                <div className="guest">
                                    <div
                                        className="login-btn"
                                        data-test="go-to-signin"
                                        onClick={this.handleClick__link(`/auth`)}
                                    >
                                        {t('_common.sign_in')}
                                    </div>
                                    <button
                                        className="button"
                                        data-size="md"
                                        data-variant="primary"
                                        data-test="go-to-signup"
                                        onClick={this.handleClick__link(`/auth?action=registration`)}
                                    >
                                        {t('_common.sign_up_2')}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    <nav
                        className={`menu-mobile${isActiveMenu ? ' is-active' : ''}`}
                        style={{ top: `${header_height}px` }}
                    >
                        {is_auth && user_details ? (
                            <>
                                <div className="account">
                                    <div className={`ava${!!user.optionalId ? ' is-admin' : ''}`}>{avaText()}</div>
                                    <div className="info">
                                        {fullName() ? <div className="full_name">{fullName()}</div> : null}
                                        <div className="email">{user_details.email}</div>
                                    </div>
                                </div>
                                <div className="divider"></div>
                            </>
                        ) : null}
                        <ul>
                            {menu_formatted().map(item => {
                                return (
                                    <li
                                        className={`${item.has_child ? 'with-dropdown' : ''}${
                                            item.has_child && item.label === drop_menu_active_label ? ' is-active' : ''
                                        }`}
                                        key={item.id}
                                    >
                                        {!item.has_child ? (
                                            <NavLink exact activeClassName="is-active" to={item.to}>
                                                {item.label}
                                            </NavLink>
                                        ) : (
                                            <div className="dropdown-block">
                                                <div
                                                    className="value"
                                                    onClick={this.handleClick__toggle_drop_menu(item.label)}
                                                >
                                                    {item.label}&nbsp;
                                                    <IconTriangleBottom />
                                                </div>
                                                <ul>
                                                    {item.children.map(item => {
                                                        return (
                                                            <li key={item.label}>
                                                                <NavLink
                                                                    exact
                                                                    activeClassName="is-active"
                                                                    to={item.to}
                                                                    onClick={this.handleClick__close_drop_menu(true)}
                                                                >
                                                                    {item.label}
                                                                </NavLink>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        )}
                                    </li>
                                )
                            })}
                        </ul>
                        {is_auth ? (
                            <>
                                <div className="divider"></div>
                                <ul>
                                    {menu_profile.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <NavLink exact activeClassName="is-active" to={item.to}>
                                                    {item.label}
                                                </NavLink>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className="current-lng-string">
                                    <div className="box" onClick={this.handleClick__open_lng_menu_mobile}>
                                        {current_lng && <img src={current_lng.icon} alt="" />}
                                        <p>{current_lng.label}</p>
                                    </div>
                                </div>
                                <div className="divider"></div>
                                <button className="logout" onClick={this.handleClick__logout}>
                                    {t('_common.logout')}
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="current-lng-string">
                                    <div className="box" onClick={this.handleClick__open_lng_menu_mobile}>
                                        {current_lng && <img src={current_lng.icon} alt="" />}
                                        <p>{current_lng.label}</p>
                                    </div>
                                </div>
                                <button
                                    className="button"
                                    data-size="md"
                                    data-variant="primary"
                                    onClick={this.handleClick__link(`/auth`)}
                                >
                                    {t('_common.sign_in')}
                                </button>
                            </>
                        )}

                        <Modal
                            settings={{ overlay_close: true }}
                            classes={{ overlay: '', modal: 'langs-style', closeButton: '', closeIcon: '' }}
                            data={{ open: is_open_lng_menu_mobile, max_width: 190 }}
                            events={{ onCloseModal: this.handleClick__close_lng_menu_mobile }}
                        >
                            <ul className="langs-modal-menu">
                                {languages
                                    .filter(el => el.is_visible)
                                    .map(el => {
                                        return (
                                            <li
                                                key={el.code}
                                                className={`${i18n.language === el.value ? 'is-active ' : ''}${
                                                    el.is_enabled ? '' : 'is-disabled '
                                                }${el.is_silent ? 'is-silent' : ''}`}
                                                onClick={this.handleClick__change_language(el)}
                                            >
                                                <img src={el.icon} alt="" />
                                                <span className={`${i18n.language === el.value ? 'is-active' : ''}`}>
                                                    {el.label}
                                                </span>
                                            </li>
                                        )
                                    })}
                            </ul>
                        </Modal>
                    </nav>
                </div>
            </header>
        )
    }
}

const mapStateToProps = state => ({
    is_auth: state.is_auth,
    user: state.user,
    user_details: state.user_details,
    header_width: state._service.styles.header_width,
    header_height: state._service.styles.header_height,
    nav_menu_width: state._service.nav_menu_width,
})

const mapDispatchToProps = dispatch => ({
    P__AUTH__LOGOUT: () => dispatch(AUTH__LOGOUT()),
    P__SERVICE__STYLES__SET_HEADER_SIZES: obj => dispatch(SERVICE__STYLES__SET_HEADER_SIZES(obj)),
    P__SERVICE__SET_NAV_MENU_WIDTH: value => dispatch(SERVICE__SET_NAV_MENU_WIDTH(value)),
    P__COMMON__SET_LANGUAGE: value => dispatch(COMMON__SET_LANGUAGE(value)),
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation('translations'),
    withRouter,
)(Header)
